// order by fit and return only the first 3 categories
const previewCategories=(categories=[])=>{
  let ret=[];
  if(categories.length) {
    categories.sort((a,b)=> a.fit < b.fit ? 1 : -1);
    ret=categories.slice(0,3);
  }
  return ret;
}


// compare a "calculating template" with its the base template
const compareCalcTemplate=(calculating, template)=>{
  let ret=[];
  const templateCats=template.categories;

  if(!templateCats) {
    console.log('(compareCalcTemplate) No template categories yet!');
    return ret;
  }

  calculating.categories.forEach(calcCat=>{
    const {_id,relevance,topics}=calcCat;
    const templateCat=templateCats.find(elem=>elem._id===_id);
    if(!templateCat) {
      console.log('====================================================================================');
      console.log('base cat not found',calcCat,template);
      return;
    }

    const baseRelevance=templateCat.relevance;
    if(relevance !== baseRelevance) {
      ret.push({catId:_id,relevance:{base:baseRelevance,new:relevance}});
    }
    // topics
    topics.forEach(elem=>{
      const {relevance}=elem;
      const topicId=elem._id;
      const templateTopic=templateCat.topics.find(elem=>elem._id===topicId);
      const baseTopicRelevance=templateTopic.relevance;

      if(!templateTopic) {
        console.log('====================================================================================');
        console.log('base cat not found',calcCat,template);
        return;
      }

      if(relevance !== baseTopicRelevance) {
        ret.push({catId:_id,topicId,relevance:{base:baseTopicRelevance,new:relevance}});
      }

    });


  });



  return ret;
}


export {
  previewCategories,
  compareCalcTemplate
}